import { gql } from "generated-graphql";

export const GET_STAFF_TENANT_SUBSCRIPTIONS = gql(`
  query StaffTenantSubscriptions(
    $search: String
    $page: Int
    $pageSize: Int
    $sort: [SortModel!]
    $reportingYear: Int
  ) {
    staffTenantSubscriptions(
      search: $search
      page: $page
      pageSize: $pageSize
      sort: $sort
      reportingYear: $reportingYear
    ) {
      items {
        tenantId
        tenantName
        salesforceAccountId
        isDemo
        isPartner
        isDisabled
        csmName
        csmEmail
        amName
        amEmail
        dataManagerName
        dataManagerEmail
        wasteManagerName
        wasteManagerEmail
        pocName
        pocEmail
        customerEngagementTier
        chemicalServiceTier
        wasteServiceTier
        epcraSubscriptionStatus
        rcraSubscriptionStatus
        insightsSubscriptionStatus
        calendarSubscriptionStatus
        chemicalsDataPipeline
        contractedIntelligencePlatformFacilities
        contractedInsightsFacilities
        contractedChemicalSubscriptionFacilities
        contractedChemicalReportingFacilities
        contractedWasteSubscriptionFacilities
        contractedWasteReportingBiennialFacilities
        contractedWasteReportingNonBiennialFacilities
        actualChemicalFacilities
        actualWasteFacilities
        actualPlatformFacilities
        actualChemicalReportingFacilities
        actualWasteReportingBiennialFacilities
        actualWasteReportingNonBiennialFacilities
        chemicalStatus
        wasteStatus
        chemicalReportingStatus
        wasteReportingBiennialStatus
        wasteReportingNonBiennialStatus
        subscriptionStatus
      }
      count
      stats {
        totalTenants
        missingSubscriptionTenants
        chemicalOverages
        wasteOverages
        chemicalWithinLimit
        chemicalReportingOverages
        wasteReportingBiennialOverages
        wasteReportingNonBiennialOverages
        totalContractedPlatformFacilities
      }
      lastSyncedAt
      reportingYear
      availableReportingYears
    }
  }
`);
